// A receipt is a container receipt (vs loose pieces) when it physically holds
// containers — `has_containers` from the API. The physical-flow signal,
// independent of the B2B availability channel.
export const isContainerReceipt = replenishment => !!replenishment?.has_containers
